var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.INVOICES.length > 0)?_c('div',{staticClass:"mt-1"},[_c('InvoiceList',{attrs:{"invoices":_vm.INVOICES,"accountantMode":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }